export var WaterWithdrawal;
(function (WaterWithdrawal) {
    WaterWithdrawal["IrrigationConsortium"] = "1";
    WaterWithdrawal["CompanyWell"] = "2";
    WaterWithdrawal["CompanyTanks"] = "3";
    WaterWithdrawal["Other"] = "4";
})(WaterWithdrawal || (WaterWithdrawal = {}));
